import type { KnowledgeItem } from '@/types';

export const offshoreKnowledge: KnowledgeItem[] = [
  {
    id: 'RIG-K001', tags: ['钻井', '工艺', '基础'],
    question: '海上钻井的基本流程是什么？',
    answer: '钻井流程：①下隔水管连接海底井口 ②用泥浆泵循环钻井液 ③转盘驱动钻杆旋转切削岩石 ④钻压控制切削深度 ⑤泥浆携带岩屑返出经振动筛分离 ⑥每钻完一段下入套管固井 ⑦遇地层流体用BOP防喷 ⑧伴生气经节流管汇到火炬塔燃烧。',
  },
  {
    id: 'RIG-K002', tags: ['泥浆', '关键参数'],
    question: '钻井泥浆的作用和关键参数？',
    answer: '泥浆四大作用：①携带岩屑返出 ②冷却润滑钻头 ③平衡地层压力防井涌 ④形成泥饼保护井壁。关键参数：流量1000~3500 L/min（保证返速≥0.6m/s）、泵压8~35 MPa、密度1.08~1.60 g/cm³（必须介于地层孔隙压力和破裂压力之间）、粘度35~50 s（漏斗粘度）。',
  },
  {
    id: 'RIG-K003', tags: ['钻压', '转速', '关键参数'],
    question: '钻压和转速怎么配合？',
    answer: '钻压80~300 kN、转速60~200 rpm。软地层用高转速低钻压（转速180~200、钻压80~150），硬地层用低转速高钻压（转速60~120、钻压200~300）。钻压过大会导致扭矩飙升、钻头过早磨损甚至卡钻；转速过低切削效率差、排屑不良。',
  },
  {
    id: 'RIG-K004', tags: ['BOP', '防喷器', '安全'],
    question: '防喷器(BOP)为什么是最后防线？',
    answer: 'BOP安装在井口，能在井涌/井喷时迅速封堵井筒。闸板密封完好度必须≥80%，控制液压14~28 MPa。井涌三步处理：①关节流阀增加环空背压 ②循环排气提高泥浆密度 ③确认压住后恢复钻进。BOP失效=井喷失控=灾难性事故。',
  },
  {
    id: 'RIG-K005', tags: ['隔水管', '张力'],
    question: '隔水管张力器的作用？',
    answer: '隔水管连接平台和海底井口，长可达1500m。张力器提供800~2500 kN恒定张力保持隔水管直立，偏角控制在5°以内。张力过低→隔水管弯曲疲劳、泥浆返出不畅；过高→设备过载。波浪和海流会影响偏角，需动态调整。',
  },
  {
    id: 'RIG-K101', tags: ['井涌', '故障', '压井'],
    question: '井涌征兆和压井流程？',
    answer: '井涌征兆：①泥浆池体积增大 ②返出量>泵入量 ③泵压下降 ④停泵后井口溢流。压井三步：①关节流阀建立环空背压 ②用加重泥浆循环替换井内流体 ③控制套压和立压在安全范围。压井液密度=地层孔隙压力当量密度+0.05~0.15 g/cm³安全余量。绝不能停泵——会让地层流体更多涌入。',
  },
  {
    id: 'RIG-K102', tags: ['卡钻', '故障'],
    question: '卡钻的类型和处理方法？',
    answer: '卡钻三种：①压差粘附（钻具贴泥饼被压差吸住）②键槽卡钻（井径变化处）③砂桥/坍塌卡钻。处理：①立即降低钻压 ②保持大排量循环洗井 ③上下活动钻具（不超过大钩安全载荷）④必要时震击解卡。不能硬拔——会把钻具拉断。预防：控制钻压、保持泥浆性能、每柱钻杆活动间隔≤3分钟。',
  },
  {
    id: 'RIG-K103', tags: ['泥浆漏失', '故障'],
    question: '泥浆漏失怎么处理？',
    answer: '漏失征兆：泵压上升但返出量骤降、泥浆池液面下降。处理：①降低泥浆密度减轻液柱压力 ②降低排量减少漏失 ③加入堵漏材料（核桃壳、云母片、石棉纤维等）④严重时打水泥塞封堵。判断：漏速<15 m³/h为轻微，15~30为中等，>30为严重需立即停钻处理。',
  },
  {
    id: 'RIG-K201', tags: ['固井', '套管'],
    question: '固井作业的要点？',
    answer: '固井用水泥浆（密度1.4~2.2 g/cm³）注入套管和井壁之间封固。泵压5~40 MPa、流量300~2000 L/min。关键：①注水泥前充分循环洗井 ②水泥浆密度均匀 ③替浆计量准确 ④候凝时间≥8小时。固井质量直接影响井筒完整性，差的固井会导致层间窜漏。',
  },
  {
    id: 'RIG-K202', tags: ['火炬', '伴生气'],
    question: '火炬塔的作用？',
    answer: '钻井过程中产出的伴生气无法回收，经节流管汇输送到火炬塔燃烧掉。燃烧量0~500 m³/h，火焰温度500~1200°C。火炬是安全措施——如果不烧掉，可燃气体在平台积聚有爆炸风险。注意风向：火炬必须在下风向位置。',
  },
  {
    id: 'RIG-K301', tags: ['海况', '安全', '撤离'],
    question: '恶劣海况什么时候要停钻撤离？',
    answer: '风速>30 m/s（12级）或有效波高>6m时必须停止钻井作业。撤离流程：①起钻到套管内 ②关闭BOP ③断开隔水管 ④平台升到安全吃水 ⑤人员撤离到直升机甲板待命。直升机甲板风速>25 m/s或能见度<3km时不允许起降。',
  },
  {
    id: 'RIG-K302', tags: ['井控', '一级二级三级'],
    question: '井控的三级防线是什么？',
    answer: '一级井控：泥浆静液压力 > 地层孔隙压力，用足够的泥浆密度预防溢流。二级井控：一级失效后，用BOP+节流管汇控制溢流并进行压井作业。三级井控：二级也失效（井喷），启用应急切断、引爆防喷器剪切闸板切断钻杆全封井口。三级井控是最后手段，意味着可能弃井。',
  },
];
